import { FmsUnitSuggestions } from '@pulse-web-ui/dadata';

import { InstanceUrls, RequestMethods, useQueryFunction } from '@shared/index';

import type { DaDataFmsUnitSuggestionsProps } from './fms-unit-suggestions.types';

export const DaDataFmsUnitSuggestion = (
  props: DaDataFmsUnitSuggestionsProps
) => {
  const queryFn = useQueryFunction(
    {
      method: RequestMethods.POST,
      url: 'api/v3/dadata/suggest/fms_unit',
    },
    InstanceUrls.DADATA_URL
  );

  return (
    <FmsUnitSuggestions
      delay={250}
      customRequest={queryFn}
      isExpandedOnFocus={!!props.unitCode}
      {...props}
    />
  );
};
